<template>
  <div>
    <va-notification
      :value="!!showError.length"
      color="danger"
      class="mb-4"
    >
      {{ showError[0] }}
    </va-notification>

    <va-card>
      <va-data-table
        :fields="fields"
        :data="items"
        :loading="loading"
        :totalPages="totalPages"
        @page-selected="readItems"
        no-data-label="Nenhuma categoria encontrada"
        api-mode
      >
        <template slot="actions" slot-scope="props">
          <va-button
            flat
            small
            color="gray"
            @click="edit(props.rowData)"
            class="ma-0"
          >
            {{ $t("tables.edit") }}
          </va-button>

          <va-button
            flat
            small
            color="danger"
            @click="remove(props.rowData)"
            class="ma-0"
          >
            {{ $t("tables.delete") }}
          </va-button>
        </template>
      </va-data-table>
    </va-card>

    <va-modal
      v-model="showConfirmModal"
      size="small"
      title="Atenção"
      :message="`Você tem certeza que deseja remover a categoria ${selectedCategory.name}?`"
      :okText=" $t('modal.confirm') "
      :cancelText=" $t('modal.cancel') "
      @ok="handleDelete"
    />
  </div>
</template>

<script>
// import axios from 'axios'
import api from '../api'

export default {
  data () {
    return {
      perPage: 10,
      totalPages: 0,
      items: [],
      loading: false,
      selectedCategory: {},
      showConfirmModal: false,
      showError: [],
    }
  },
  computed: {
    fields () {
      return [
        {
          name: 'name',
          title: this.$t('tables.headings.name'),
        },
        {
          name: '__slot:actions',
          dataClass: 'text-right',
        },
      ]
    },
  },
  created () {
    this.readItems()
  },
  methods: {
    readItems (page = 0) {
      if (page > 0) {
        page -= 1;
      }

      this.loading = true

      // HERE FETCH categorias
      api.get(`/category?page=${page}&size=${this.perPage}`)
        .then(response => {
          this.items = response.data.content
          this.totalPages = response.data.totalPages
        })
        .catch(err => {
          console.log(err.message)
          this.showError = ['Houve um problema em listar as categorias. Por favor, tente novamente.']

          setTimeout(() => {
            this.showError = []
          }, 3000)
        })
        .finally(() => {
          this.loading = false
        })
    },
    edit (categoria) {
      this.$router.push({ name: 'edit-category', params: { id: categoria.id } })
    },
    remove (categoria) {
      this.showConfirmModal = true
      this.selectedCategory = categoria
    },
    handleDelete () {
      api.delete(`/category/${this.selectedCategory.id}`)
        .then(res => {
          this.showToast('Categoria removida com sucesso')

          const idx = this.items.findIndex((u) => u.id === this.selectedCategory.id)
          this.items.splice(idx, 1)
        })
        .catch(err => {
          console.log(err.message)
          this.showError = ['Não foi possível remover a categoria. Tente novamente mais tarde']

          setTimeout(() => {
            this.showError = []
          }, 3000)
        })
    },
  },
}
</script>

<style lang="scss">
.data-table-server-pagination---avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
</style>
